import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Guest Guard - Prevents authenticated users from accessing auth pages (login, register, etc.)
 * Redirects authenticated users to the home page
 */
export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    // User is already logged in, redirect to home
    router.navigate(['/']);
    return false;
  }

  // User is not authenticated, allow access to auth pages
  return true;
};
